import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { maxBy } from 'lodash'

import SplitOrder from '../../../components/tabs/OrderDetailsModal/SplitOrder'

import { makeGetTabOrder } from '../../../selectors/order'
import { makeGetDisplaySuiteByOrder } from '../../../selectors/suites'

import { TabOrderDetailsViewModel } from '../../../viewmodels/TabOrderViewModel'

const mapStateToProps = (state, ownProps) => {
  const orderId = ownProps?.match?.params?.orderId ?? ''
  const getTabOrder = makeGetTabOrder()
  const getDisplaySuite = makeGetDisplaySuiteByOrder()
  const suiteInformation = getDisplaySuite(state, orderId)
  const tabOrder = getTabOrder(state, orderId)
  const order = TabOrderDetailsViewModel(tabOrder)
  const remoteOrderTotal = maxBy([order.orderTotalFromOrder, order.remoteOrderTotal], 'updatedAt') || {}

  const userNotes = order?.userNotes ?? ''

  return {
    ...order,
    remoteOrderTotal,
    suiteInformation,
    userNotes,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const replace = ownProps?.history?.replace ?? function(){}

  return {
    onClose: () => replace('/tabs'),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SplitOrder))
